import type { PlainButtonProps, StyledPlainButtonProps } from '@bos/ui';
import { PlainButton } from '@bos/ui';

import type { ReplaceTestIdWithAppOne } from '../const/testIds';

export type AppPlainButtonProps = ReplaceTestIdWithAppOne<
	PlainButtonProps & StyledPlainButtonProps
>;

export const AppPlainButton = (props: AppPlainButtonProps) => (
	<PlainButton type={'button'} {...props} />
);
